'use strict';

import * as Props from '../Props';

const angular = require('angular');

const SectionProperties = {
    Basic: {
        'ControlType': 'Section',
        'Label': {
            name: 'label',
            selectedValue: 'Section',
            type: 'textbox',
            hidden: true
        },
        'Field Name': Props.getFieldName('Section'),
        'Data Field Name': Props.getDataFieldName('Section'),
        'DSName': {
            selectedValue: '',
            hidden: true
        },
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        }
    },
    Display: {
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Style: {
        'font-style-group': {
            type: 'style-group',
            members: {
                'background-color': {
                    type: 'color-picker',
                    title: 'background.color',
                    selectedValue: '#ffffff',
                    icon: 'fa fa-paint-brush',
                    onChangeFunction: 'updateStyle'
                }
            }
        },
        'style-group': {
            type: 'style-group',
            members: {}
        },
        'Name': {
            selectedValue: 'style',
            hidden: true
        }
    },
    Margin: angular.copy(Props.marginObject),
    Events: {
        Name: angular.copy(Props.elementEventsObject).Name,
        load: angular.copy(Props.elementEventsObject).load
    }
};

export default SectionProperties;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Section.ts